export const titles = ['Name', 'Processing fee', ''];
export const template = '1fr 1fr 24px';
